<template>
    <div class="card-form">
        <h3>{{ $t('lang.main.subs_form') }}</h3>
        <payed-till :payed-till="payedTill" :expired="expired"></payed-till>
        <div class="card">
            <h6>{{ tariff.label }}</h6>
            <AdaptersMessage :message="$t('lang.main.subs_form_archive_tariff')" severity="info" />
        </div>
    </div>
</template>

<script>
import PayedTill from "./PayedTill.vue";
import AdaptersMessage from "../adapters/Message.vue";

export default {
    name: "ArchivedTariff",
    props: {
        tariff: {
            type: Object,
            required: true
        },
        payedTill: {
            type: Date,
        },
        expired: {
            type: Boolean,
            default: () => false,
        }
    },
    components: {
        PayedTill,
        AdaptersMessage,
    },
}
</script>
